import { useTranslation } from 'react-i18next'

import { EyeSlashIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import { missingDataLabels, notActiveOnLabels } from './constants'
import { getBarShortLabel, getVisibleCriteriaNames } from './helpers'
import * as Styles from './styles'

const HiddenBlockPlaceholder = ({ blockName, hiddenReasons, isBar, isMobileView }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const { visibleNames, hiddenCount } = getVisibleCriteriaNames(hiddenReasons.criteriaNames)
  const hasCriteria = visibleNames.length > 0
  const barShortLabel = getBarShortLabel(hiddenReasons)
  const hiddenByLabel = isBar ? `${t('Oculto por')}:` : t('Oculto por')

  if (isBar && isMobileView) {
    return (
      <Styles.Container isBar isMobileView>
        <Styles.Title type="titleS">{blockName}</Styles.Title>
        {barShortLabel && <Text type="bodySRegular">{t(barShortLabel)}</Text>}
      </Styles.Container>
    )
  }

  return (
    <Styles.Container isBar={isBar}>
      <Styles.Title isBar={isBar} type={isBar ? 'titleS' : 'titleM'}>
        {blockName}
      </Styles.Title>
      <Styles.ReasonsRow isBar={isBar}>
        <Styles.HiddenBy>
          <EyeSlashIcon size={24} />
          <Text type="bodyMMedium">{hiddenByLabel}</Text>
        </Styles.HiddenBy>
        <Styles.ReasonList isBar={isBar}>
          {hiddenReasons.notActiveOn && (
            <Styles.Reason isBar={isBar}>
              <Text type="bodyMMedium">{t(notActiveOnLabels[hiddenReasons.notActiveOn])}</Text>
            </Styles.Reason>
          )}
          {hiddenReasons.missingData && (
            <Styles.Reason isBar={isBar}>
              <Text type="bodyMMedium">{t(missingDataLabels[hiddenReasons.missingData])}</Text>
            </Styles.Reason>
          )}
          {hasCriteria && (
            <Styles.Reason isBar={isBar}>
              <Text type="bodyMMedium">{`${t('Criterios')}:`}</Text>
              <Styles.CriteriaPills isBar={isBar}>
                {visibleNames.map(criterionName => (
                  <Chip
                    key={criterionName}
                    label={criterionName}
                    backgroundColor={theme.colors.primary.surface}
                    color={theme.colors.primary.onSurface}
                  />
                ))}
                {hiddenCount > 0 && <Text type="bodySRegular">{t('+{{count}} más', { count: hiddenCount })}</Text>}
              </Styles.CriteriaPills>
            </Styles.Reason>
          )}
        </Styles.ReasonList>
      </Styles.ReasonsRow>
    </Styles.Container>
  )
}

export default HiddenBlockPlaceholder
